import { Appointment } from '@weave/schema-gen-ts/dist/schemas/schedule/calendar-events/v1/calendar_events.pb';
import { CalendarEvent } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import { prepareAppointmentData } from '../../utils/appointment-helper';
import { useGetCalendarStartEndDate } from '../use-get-calendar-start-end-date';
import { useGetInsuranceStatuses } from '../use-get-insurance-status';
import { useGetSchedulePulseInsuranceTabAppointments } from '../use-get-schedule-pulse-insurance-tab-appointments';

type useSchedulePulseInsuranceAppointmentStatsParamsType =
  | {
      // Case 1: selectedDate is required
      selectedDate: string;
      widgetStartDate?: never;
      widgetEndDate?: never;
      locationIds: string[];
    }
  | {
      // Case 2: widgetStartDate and widgetEndDate are required
      selectedDate?: never;
      widgetStartDate: string;
      widgetEndDate: string;
      locationIds: string[];
    };

/*
 This hook is responsible for fetching the appointments data and on top of it constructing  the unverified and error insurance status appointments of selected date range and totalinsurnace statuses
 which is used for 2 widgets verify-analytics and verify-insurance
*/
export const useSchedulePulseInsuranceAppointmentStats = ({
  selectedDate,
  widgetStartDate,
  widgetEndDate,
  locationIds,
}: useSchedulePulseInsuranceAppointmentStatsParamsType) => {
  let { startDate, endDate } = useGetCalendarStartEndDate(selectedDate || '');
  startDate = startDate || widgetStartDate || '';
  endDate = endDate || widgetEndDate || '';

  const { allAppointmentsData, isLoadingAppointmentsData, isScheduleV3FlagEnabled } =
    useGetSchedulePulseInsuranceTabAppointments({
      widgetStartDate: startDate,
      widgetEndDate: endDate,
      locationIds: locationIds,
    });

  const { isLoading: isLoadingInsuranceStats, insuranceStatuses } = useGetInsuranceStatuses({
    appointments: allAppointmentsData || [],
    scheduleSelectedLocationIds: locationIds,
  });

  const constructedAppointmentInsuranceStatusData = allAppointmentsData?.reduce(
    (acc, appointment) => {
      const personId = isScheduleV3FlagEnabled
        ? (appointment as CalendarEvent)?.attendeeId
        : (appointment as Appointment)?.person?.personId || '';

      const coverageStatus =
        insuranceStatuses?.locationVerificationCounts?.[appointment.locationId || '']?.coverageStatusByPersonId?.[
          personId || ''
        ];

      if (coverageStatus === 'Unverified' || coverageStatus === 'Error') {
        const appData = prepareAppointmentData(appointment, isScheduleV3FlagEnabled, coverageStatus);
        acc.push({ ...(appData || {}) });
      }

      return acc;
    },
    [] as {
      id: string;
      name: string;
      appointmentTime: string;
      insuranceStatus: string;
      locationId: string;
    }[]
  );
  return {
    isLoading: isLoadingAppointmentsData || isLoadingInsuranceStats,
    insuranceStatuses: insuranceStatuses,
    appointmentsData: constructedAppointmentInsuranceStatusData || [],
  };
};
